import React, { useContext } from 'react';
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { setContext, setVehicle, setVehiclesConfig, setVehiclesStock, setFinParameters, setAvailableOptions,
  setAvailableaccessories, setPartExchange, setVehicleExamples } from '../actions/actionsAppTest';
import { fetchSimulationVehicleDetailsIfNeeded, fetchSimulationVehiclesIfNeeded, fetchSimulationOptionsIfNeeded,
  fetchSimulationAccessoriesIfNeeded } from '../actions/actionsApiSimulation';
import TestJson from '../components/testCriteria/TestJson'


export default function ContTestJson() {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onChangeContext(context, perimeterFilter, vehDescType) {
    fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, {context:context}, null, false, false);
    fetchSimulationOptionsIfNeeded(globalstate, dispatch, {context:context}, null, null, false);
    fetchSimulationAccessoriesIfNeeded(globalstate, dispatch, {context:context}, null, null, false);
    fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {context:context}, null, null, null, false);
    dispatch(setVehicleExamples(context, {...globalstate.settings,vehDescType:vehDescType}));
    dispatch(setContext(context, perimeterFilter, vehDescType))
  }

  function onChangeVehicle(vehicle) {
    fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, {vehicle:vehicle}, null, false);
    fetchSimulationOptionsIfNeeded(globalstate, dispatch, {vehicle:vehicle}, null, null, false);
    fetchSimulationAccessoriesIfNeeded(globalstate, dispatch, {vehicle:vehicle}, null, null, false);
    dispatch(setVehicle(vehicle))
  }

  function onChangeAvailableOptions(availableOptions) {
    fetchSimulationOptionsIfNeeded(globalstate, dispatch, {}, availableOptions, null, false);
    dispatch(setAvailableOptions(availableOptions))
  }

  function onChangeAvailableAccessories(availableAccessories) {
    fetchSimulationAccessoriesIfNeeded(globalstate, dispatch, {}, availableAccessories, null, false);
    dispatch(setAvailableaccessories(availableAccessories))
  }

  function onChangeVehiclesConfig(vehicles) {
    fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {}, {vehiclesConfig:vehicles}, null, null, false);
    dispatch(setVehiclesConfig(vehicles))
  }

  function onChangeVehiclesStock(vehicles) {
    fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {}, {vehiclesStock:vehicles}, null, null, false);
    dispatch(setVehiclesStock(vehicles))
  }

  function onChangeParameters(parameters) {
    var paramsFetch = parameters == null ? '' : parameters;
    fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, {parameters:paramsFetch}, null, false);
    fetchSimulationOptionsIfNeeded(globalstate, dispatch, {parameters:paramsFetch}, null, null, false);
    fetchSimulationAccessoriesIfNeeded(globalstate, dispatch, {parameters:paramsFetch}, null, null, false)
    fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {parameters:paramsFetch}, null, null, null, false);
    dispatch(setFinParameters(parameters))
  }

  function onChangePartExchange(value) {
    var partExchange = value == null ? '' : value;
    dispatch(setPartExchange(partExchange));
    fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, {partExchange:partExchange}, null, false);
    fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {partExchange:partExchange}, null, null, null, false);
  }

  return (
    <TestJson
      settings={globalstate.settings}
      context={globalstate.testCriteria.context}
      vehicle={globalstate.testCriteria.vehicle}
      availableOptions={globalstate.testCriteria.availableOptions}
      availableAccessories={globalstate.testCriteria.availableAccessories}
      vehiclesStock={globalstate.testCriteria.vehiclesStock}
      vehiclesConfig={globalstate.testCriteria.vehiclesConfig}
      parameters={globalstate.testCriteria.parametersForFetch}
      partExchange={globalstate.testCriteria.partExchange}
      onChangeContext={onChangeContext}
      onChangeVehicle={onChangeVehicle}
      onChangeAvailableOptions={onChangeAvailableOptions}
      onChangeAvailableAccessories={onChangeAvailableAccessories}
      onChangeVehiclesConfig={onChangeVehiclesConfig}
      onChangeVehiclesStock={onChangeVehiclesStock}
      onChangeParameters={onChangeParameters}
      onChangePartExchange={onChangePartExchange}
    />
  );
}
